import { render, staticRenderFns } from "./ai2.vue?vue&type=template&id=3ca13278&"
import script from "./ai2.vue?vue&type=script&lang=js&"
export * from "./ai2.vue?vue&type=script&lang=js&"
import style0 from "./ai2.vue?vue&type=style&index=0&id=3ca13278&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports